import { LineItemAutocompleteField } from "components/formFields/LineItemAutocompleteField";
import { LineTableCell } from "components/formFields/LineTableCell";

export function LineTaxCode(props) {
  const { value, taxCodes, onValueChange, lineReadOnly = false } = props;

  return (
    <LineTableCell sx={{ minWidth: "8rem" }}>
      <LineItemAutocompleteField
        name="taxCode"
        options={taxCodes}
        value={value}
        onValueChange={onValueChange}
        lineReadOnly={lineReadOnly}
        allowTooltip
        disableClearable
      />
    </LineTableCell>
  );
}
